<template>
  <!-- 该轮播图样式为 轮播图带描述 eg: https://www.fjdynamics.com/product/al01-3d-land-leveling-system 最后一屏轮播样式 -->
  <section class="swiper-carousel">
    <div class="" :style="carouselWrap">
      <h2 class="m-0 ta-c ff-asb c-26">{{ $t(title) }}</h2>
      <div class="area-8-swiper ov-h p-r" id="area-8-swiper">
        <div class="swiper-wrapper">
          <client-only>
            <swiper class="" :options="swiperOption" ref="swiper">
              <swiper-slide v-for="(item, index) in swiperData" :key="index">
                <i class="d-b img-box" :style="wrapperStyle">
                  <video
                    v-if="item.videoSrc"
                    width="100%"
                    height="100%"
                    x5-playsinline
                    x5-video-player-type="h5"
                    x-webkit-airplay="allow"
                    playsinline
                    webkit-playsinline
                    muted
                    loop
                    :src="item.videoSrc"
                    :data-src="item.videoSrc"
                    :poster="item.img"
                  ></video>
                  <img v-else width="100%" height="100%" v-lazy="item.img" alt="" srcset="" />
                </i>
                <div v-if="item.isHtml" v-html="item.vHtml" class="text"></div>
                <div v-else class="text">
                  {{ $t(item.desc) }}
                </div>
              </swiper-slide>
            </swiper>
          </client-only>
        </div>
        <div class="area-8-swiper-tab-wrap w-100p p-a z-3" :style="paginationStyle">
          <div class="area-8-swiper-tab d-f jc-sb"></div>
          <i class="line" ref="swiperLine"></i>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Carousel',
    props: {
      title: {
        type: String,
        default: ''
      },
      swiperOption: {
        type: Object,
        default: () => {}
      },
      swiperData: {
        type: Array,
        default: () => []
      },
      // 外部容器样式大小
      carouselWrap: {
        type: Object,
        default: () => {}
      },
      // 自定义轮播图容器大小
      wrapperStyle: {
        type: Object,
        default: () => {}
      },
      // 分页器自定义样式
      paginationStyle: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {}
    },
    created() {},
    mounted() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .swiper-carousel {
    padding: 1.6rem 0;
  }
  .swiper-carousel h2 {
    margin-bottom: 0.32rem;
    font-size: 0.48rem;
  }
  :deep(.area-8-swiper .img-box) {
    height: 6.75rem;
    margin-bottom: 1.12rem;
    background-color: #fff;
  }
  :deep(.area-8-swiper .swiper-slide div) {
    display: none;
  }
  :deep(.area-8-swiper .swiper-slide-active div) {
    display: block;
    color: #333;
    outline: none;
  }
  :deep(.area-8-swiper-tab-wrap) {
    top: 6.75rem;
    left: 0;
    padding-top: 0.16rem;
    border-bottom: 1px solid #979797;
    text-align: center;
  }
  :deep(.area-8-swiper-tab-wrap span) {
    display: inline-block;
    width: 33.333%;
    // padding: 0.16rem 0;
    cursor: pointer;
    font-size: 0.2rem;
    color: #666;
  }
  :deep(.area-8-swiper-tab-wrap .line) {
    display: inline-block;
    content: '';
    will-change: transform;
    transition: transform 0.3s linear;
    position: absolute;
    left: 0;
    bottom: -1px;
    width: 33.333%;
    height: 2px;
    background-color: #333;
  }
  :deep(.area-8-swiper .swiper-pagination-bullets .swiper-pagination-bullet) {
    margin: 0.16rem 0;
    height: 0.3rem;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :deep(.area-8-swiper .swiper-pagination-bullets .swiper-pagination-bullet-active) {
    font-weight: 500;
    color: #333;
  }
</style>
